import { gsap, ScrollTrigger } from "../global/gsap";

const initListing = (listingEl) => {
    const groups = listingEl.querySelectorAll('.js-group');
    const navItems = listingEl.querySelectorAll('.js-nav-item');
    const overviewItems = listingEl.querySelectorAll('.js-overview');
    const cards = listingEl.querySelectorAll('.js-dashboard-card');
    const info = listingEl.querySelector('.js-info');

    let isScrolling = false;

     const mm = gsap.matchMedia();

    mm.add('(min-width: 901px)', () => {

        groups.forEach((group, i) => {
            const color = group.getAttribute('data-color');
            const startTrigger = (i === 0) ? "top 100%" : "top 40%";

            const updateUI = (index) => {
                if (isScrolling) return;

                listingEl.querySelectorAll('.is-active').forEach(el => el.classList.remove('is-active'));
                const targets = [overviewItems[index], navItems[index]];

                targets.forEach(el => el?.classList.add('is-active'));
                group.classList.add('is-active');
                gsap.to(listingEl, { backgroundColor: color, duration: 1, overwrite: 'auto' });
            };

            ScrollTrigger.create({
                trigger: group,
                start: startTrigger,
                end: "bottom 50%",
                onEnter: () => {
                    updateUI(i);
                },
                onEnterBack: () => {
                    updateUI(i);
                }
            });
        });

        // pin overview to top of parent section
        ScrollTrigger.create({
            trigger: listingEl,
            pin: info,
            start: "top top",
            end: "bottom bottom",
            pinSpacing: false,
            toggleClass: { targets: "body", className: "is-pinned" }
        });

        // custom load in for cards
        gsap.set(cards, {
            opacity: 0,
            x: 50
        });

        ScrollTrigger.batch(cards, {
            invalidateOnRefresh: true,
            start: 'top 75%',
            onEnter: (batch) => gsap.to(
                batch, {
                    duration: 0.6,
                    opacity: 1,
                    x: 0,
                    stagger: 0.1,
                    ease: 'power2.inOut'
                }
            )
        });

        // navigation
        navItems.forEach((anchor, i) => {
            anchor.addEventListener("click", (e) => {
                e.preventDefault();

                isScrolling = true;
                const target = groups[i];

                // manually update the active states of the nav and overview items, since we're bypassing the scroll trigger
                listingEl.querySelectorAll('.is-active').forEach(el => el.classList.remove('is-active'));
                const targets = [overviewItems[i], navItems[i], groups[i]];

                targets.forEach(el => el?.classList.add('is-active'));

                const color = groups[i].getAttribute('data-color');
                gsap.to(listingEl, { backgroundColor: color, duration: 1, overwrite: 'auto' });

                gsap.to(window, {
                    duration: 1,
                    scrollTo: {
                        y: target,
                        autoKill: true
                    },
                    ease: "power2.inOut",
                    onComplete: () => {
                        isScrolling = false;
                    },
                    onInterrupt: () => {
                        isScrolling = false;
                    }
                });
            });
        });

    });
};

export { initListing as default };
